import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { DateParsersService } from 'rev-shared/date/DateParsers.Service';
import { buildUrl, parseUrl } from 'rev-shared/util/UrlUtil';
import { WebcastVideoSource } from '../webcast/WebcastVideoSource';
import { IRtmpSettings } from './IRtmpSettings';

const rtmp = 'rtmp';
const rtmps = 'rtmps';
const srt = 'srt';
const rtmpPort = '1937';
const rtmpsPort = '1936';
const srtPort = '9000';
@Injectable({
	providedIn: 'root'
})
export class RtmpVideoSourceDetailsService {
	constructor(
		private readonly DateParsers: DateParsersService,
		private readonly http: HttpClient
	) {}

	public getRtmpUrlDetails(isSecure: boolean, webcastType: WebcastVideoSource, webcastId: string, isPrimary: boolean): Observable<{ url: string; streamKey: string; rtmpPort: number; rtmpsPort: number }> {
		const streamType = isPrimary ? 'primary' : 'backup';
		return this.http.post<{ url: string; streamKey: string; rtmpPort: number; rtmpsPort: number }>(`/scheduled-events/rtmp-url/${streamType}/${webcastId}`, {
			isSecure: (isSecure || 'false').toString(),
			sourceType: webcastType
		});
	}

	public getRtmpVideoSourceSchedules(startDateInIso: string, endDateInIso: string, url: string, webcastType: WebcastVideoSource): Observable<any> {
		return this.http.get<any>(`/scheduled-events/rtmp/schedule`, {
			params: {
				startDate: startDateInIso,
				endDate: endDateInIso,
				url,
				webcastType
			}
		}).pipe(
			map(events => (events || []).map(event => {
				return {
					...event,
					startDate: this.DateParsers.parseUTCDate(event.startDate),
					endDate: this.DateParsers.parseUTCDate(event.endDate)
				};
			}))
		);
	}
}

export function updateRtmpUrl(url: string, isSecure: boolean, streamKey: string, webcastType: WebcastVideoSource, rtmpSettings?: Pick<IRtmpSettings, 'rtmpPort' | 'rtmpsPort'>): string {
	const parsedUrl = parseUrl(url);
	if (webcastType === WebcastVideoSource.SRT) {
		return buildUrl(
			srt,
			parsedUrl.host,
			srtPort,
			`?passphrase=${streamKey}&pbkeylen=32`
		);
	}

	return buildUrl(
		isSecure ? rtmps : rtmp,
		parsedUrl.host,
		isSecure ? String(rtmpSettings?.rtmpsPort ?? rtmpsPort) : String(rtmpSettings?.rtmpPort ?? rtmpPort),
		parsedUrl.path
	);
}
